import React from 'react';
import PropTypes from 'prop-types';
import { TextField, Button } from '@decisiv/ui-components';
import Flex from '@decisiv/ui-components/lib/components/Flex';
import ArrowRight from '@decisiv/iconix/lib/components/ArrowRight';
import { InstructionsDiv, Strong } from './styledComponents';
import useSetEmail from '../hooks/useSetEmail';

function EmailRequestForm({
  userId,
  csrfToken,
  onContinue,
  onContinueNoPost,
  onFail,
  translations,
}) {
  const { setEmail, postEmail, isDirty } = useSetEmail(
    userId,
    csrfToken,
    onContinue,
    onFail,
  );
  return (
    <>
      <InstructionsDiv>{translations.emailInstructions}</InstructionsDiv>
      <Flex marginBottom={1} flexDirection="column">
        <Strong style={{ marginBottom: 10 }}>
          {translations.emailAddressLabel}
        </Strong>
        <TextField
          label={translations.emailFieldLabel}
          name="Email"
          type="Email"
          onChange={(e) => setEmail(e.target.value)}
        />
      </Flex>
      <Flex marginTop={1}>
        <Button
          style={{ marginRight: '10px' }}
          icon={ArrowRight}
          text={translations.addEmailAddress}
          iconPosition="right"
          disabled={isDirty()}
          onClick={() => postEmail()}
        />
      </Flex>
      <Flex marginTop={1}>
        <Button
          text={translations.continueToPortal}
          kind="secondary"
          onClick={() => onContinueNoPost()}
        />
      </Flex>
    </>
  );
}

EmailRequestForm.propTypes = {
  userId: PropTypes.number.isRequired,
  csrfToken: PropTypes.string.isRequired,
  onContinue: PropTypes.func.isRequired,
  onContinueNoPost: PropTypes.func.isRequired,
  onFail: PropTypes.func.isRequired,
  translations: PropTypes.objectOf(PropTypes.string),
};

EmailRequestForm.defaultProps = {
  translations: {},
};

export default EmailRequestForm;
